import { CustomerProductName } from 'src/constants/customer/enums'
import { CustomerProductsTableFields } from './enums'

/**
 * Human labels for the six backend product names.
 *
 * An exhaustive `Record` rather than a lookup with a fallback: if a new `PartnerProductName`
 * is mirrored into `CustomerProductName`, this fails typechecking instead of quietly
 * rendering a raw snake_case string in the table.
 */
export const customerProductLabels: Record<CustomerProductName, string> = {
  [CustomerProductName.GigSafe]: 'GigSafe',
  [CustomerProductName.Payments]: 'Payments',
  [CustomerProductName.Subcontractor]: 'Subcontractor',
  [CustomerProductName.ApiIntegration]: 'API Integration',
  [CustomerProductName.McLite]: 'MC Lite',
  [CustomerProductName.Opportunities]: 'Opportunities',
}

/**
 * The fan-out's input. `GET /products` requires a `product`, so listing a customer's products
 * means one request per name — see the plan's Global Constraints and ENG-732.
 */
export const CUSTOMER_PRODUCT_NAMES: CustomerProductName[] = Object.values(CustomerProductName)

export const customerProductTableHeaderTitles: Record<CustomerProductsTableFields, string> = {
  [CustomerProductsTableFields.id]: 'ID',
  [CustomerProductsTableFields.product]: 'Product',
  // The (UTC) suffix is load-bearing: the backend stores these as wall-clock times relabelled
  // as UTC, and the grid renders them in UTC rather than the admin's local zone.
  [CustomerProductsTableFields.startTime]: 'Start time (UTC)',
  [CustomerProductsTableFields.endTime]: 'End time (UTC)',
  // The actions column is icon-and-button only; a header would just add noise.
  [CustomerProductsTableFields.actions]: '',
}

// At most six rows per customer, so this stops at 100 like the markets list.
export const customerProductPageSizeOptions = [25, 50, 100]

export const CUSTOMER_PRODUCTS_GRID_COLUMNS_STORAGE_KEY = 'admin.customerProducts.gridColumns'
